import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { analytics } from 'core/analytics';
import { Link } from 'core/routing';
import { clientStore } from 'apps/client/app';

export const RepoFileLink = ({
  fileInfo,
  children,
  content,
  version,
  draggable = false,
}) => {
  const baseRoute = clientStore.spaceRoute.route + (version ? '.version' : '');
  const { reference } = fileInfo;
  const fileRoute = reference.isFolder
    ? `${baseRoute}.files.directory`
    : `${baseRoute}.file`;
  const basepath = reference.path;

  const params = { ...clientStore.spaceParams };
  if (basepath) params.basepath = basepath;
  if (version) params.contributionId = version;

  return (
    <RepoStyleLink
      name={fileRoute}
      params={params}
      content={content}
      openTab={{
        title: reference?.filename || '',
        iconType: 'file',
      }}
      draggable={draggable}
    >
      {children}
    </RepoStyleLink>
  );
};

export const FileLink = ({ fileInfo, children, content }) => {
  const { reference } = fileInfo;
  const { isFolder } = reference;
  if (!isFolder) {
    if (clientStore.signedInProfile) {
      return (
        <A
          onClick={() => {
            analytics.sendEvent('downloaded-project');
          }}
          href={reference.downloadPath}
          download
          target='_blank'
        >
          {children}
        </A>
      );
    }
    return (
      <span
        onClick={() => {
          clientStore.routerStore.navigate('home.signIn', {
            next: clientStore.next(),
          });
        }}
      >
        {children}
      </span>
    );
  }
  return (
    <RepoFileLink fileInfo={fileInfo} content={content}>
      {children}
    </RepoFileLink>
  );
};

export const A = styled.a`
  color: ${props => props.theme.color.primary};
  &:hover {
    text-decoration: underline;
  }
`;

const RepoStyleLink = styled(Link)`
  color: ${props => props.theme.color.primary};
  &:hover {
    text-decoration: underline;
  }
`;

RepoFileLink.propTypes = {
  fileInfo: PropTypes.object,
  content: PropTypes.object,
  version: PropTypes.string,
  draggable: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};

FileLink.propTypes = {
  fileInfo: PropTypes.object,
  content: PropTypes.object,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};
